import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import NoData from './../../no-data/no-data.component';

// styles , icons and images
import { Row, Col, Card, Modal } from 'react-bootstrap';
import { Paper} from '@material-ui/core';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import img from '../../../images/image-place.png';
// import EmojiFlagsIcon from '@material-ui/icons/EmojiFlags';
// import EditIcon from '@material-ui/icons/Edit';
// import DeleteIcon from '@material-ui/icons/Delete';
// import ShareIcon from '@material-ui/icons/Share';
// import dots from '../../../images/more.png';


export default function CardVisumes(props){
        const [bioSelected , setBioSelected] = useState();
        const [show , setShow] = useState(false);

        const handleShowVideo = (bio) => {
            setBioSelected(bio);
            setShow(true);
        }
        const handleClose = () =>  setShow(false);
        const ShowVideo = () => (
             <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="row m-0 modal-video pr-0 biographies"
                    show={show}
                    onHide={handleClose}>
                    <Col xs={12} className="p-0">
                        <Modal.Body className="row m-0 p-0  bg-white rounded border-0">
                            <Col xs={11} className="text-left p-0 bold p-2 pt-3 pb-2 captialize">
                                <h6>{bioSelected?.title}</h6>
                            </Col>
                            <Col  xs={12} className="p-0 order-sm-4 order-2 bg-black rounded">
                                <video controls autoPlay className="custom-iframe" title={bioSelected?.title} src={(bioSelected?.video) ? bioSelected.video.url : ''} width="100%" style={{ maxHeight: '33rem' }}></video>
                            </Col>
                            {/* <Col md={2} xs={12} className="bg-lightgrey order-sm-5 order-5 modal-list-hight pr-1 pl-1">
                                {
                                    this.arrayOfDuration.map(question =>
                                        (question.video !== null) ?
                                            <button type="button"
                                                className="bg-transparent btn-cuePoint p-0 w-100 rounded border-bottom border-0"
                                                onClick={e => {
                                                    let video = document.querySelector('.custom-iframe');
                                                    video.currentTime = question.start_time
                                                }}>
                                                <Row className="m-0  pb-2">
                                                    <Col xs={1} className="p-0">
                                                        <EmojiFlagsIcon style={{ fontSize: "1rem" }} />
                                                    </Col>
                                                    <Col xs={11} className="p-0  text-left">
                                                        <p className="d-inline-block pl-2 captialize mb-0">
                                                            {(question.title.length <= 15) ? question.title : question.title.substring(0, 15) + "..."}
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </button> : ''
                                    )
                                }
                            </Col> */}
                        </Modal.Body>
                    </Col>
                </Modal>
             )
        if (!props.data[0]) {
            return (
                <NoData />
            )
        }
        else {
            return (
                <Row className="m-0 p-3 pt-4 ">
                    {props.data.map(bio => {
                        return (
                            <Col className="p-3 " md='4'>
                                <Card className="text-dark border-0 biographies">
                                    {(bio.video) ?
                                        <Paper elevation={3} className="play-icon-container bg-black rounded">
                                            <button type="button"
                                                className="bg-transparent border-0 p-0 play-icon-container"
                                                onClick={e => handleShowVideo(bio)}>
                                                <Card.Img className="" src={bio.video?.frame?.url? bio.video.frame.url: 'https://via.placeholder.com/150' } style={{ maxHeight: "7rem" }} alt="Card image" />

                                                <div className="text-white play-icon row m-0 align-items-center">
                                                    <PlayCircleFilledIcon className="col" style={{ fontSize: '50px' }} />
                                                </div>
                                            </button>
                                        </Paper>
                                        :
                                        <Paper elevation={3} >
                                                <Card.Img className="" src={img} style={{ maxHeight: "7rem" }} alt="Card image" />
                                        </Paper>
                                    }
                                    <Row className="m-0">
                                        <Col xs={10} className="text-left p-0 bold captialize mt-3">{bio.title}</Col>
                                    </Row>
                                    <Row className="m-0 pt-1  text-grey">
                                        <Col xs={9} className="text-left p-0"><span className="text-orange">{bio.speciality?.name} </span><br />{(bio.video)?bio.created_at.substring(0, 10): ''}</Col>
                                        <Col xs={3} className="text-right p-0">{bio.video.duration} Sec</Col>
                                    </Row>
                                </Card>
                            </Col>
                        )})}
                        <ShowVideo />
                </Row>
            )
        }
}